/**
 * VisitorLayout Component
 *
 * Layout wrapper for unauthenticated visitor pages.
 * Renders SharedLandingNavbar at top, page content in a flex-grow container,
 * and ReusableFooter at bottom. Includes a toolbar offset spacer to account
 * for the fixed-position navbar.
 *
 * Supports both children (for backward compatibility with DualLayoutRoute)
 * and Outlet (for nested layout route pattern). When no children are passed,
 * renders the matched child route via Outlet.
 *
 * Requirements: 3.1, 3.3, 4.1, 5.1, 6.1, 6.2, 6.3, 7.2
 */

import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { SharedLandingNavbar } from './SharedLandingNavbar';
import { ReusableFooter } from './ReusableFooter';

export interface VisitorLayoutProps {
    children?: React.ReactNode;
}

export function VisitorLayout({ children }: VisitorLayoutProps): JSX.Element {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
            <SharedLandingNavbar />
            {/* Toolbar offset spacer to account for fixed navbar */}
            <Box sx={{ height: { xs: 56, sm: 64 } }} />
            {/* Page content - renders children if provided, otherwise Outlet for nested routes */}
            <Box sx={{ flexGrow: 1 }}>
                {children ?? <Outlet />}
            </Box>
            <ReusableFooter />
        </Box>
    );
}
